"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const timeago_js_1 = require("timeago.js");
const ObjectivesClient_1 = require("client/ObjectivesClient");
const MetricsContext_1 = require("context/MetricsContext");
const MetricsContext_2 = require("context/MetricsContext");
const RefetchQueryContext_1 = require("context/RefetchQueryContext");
const ToastContext_1 = require("context/ToastContext");
const UserContext_1 = require("context/UserContext");
const HelperUtils_1 = require("utils/HelperUtils");
const AWSImage_1 = __importDefault(require("components/design-system/AWSImage"));
const Button_1 = __importDefault(require("components/design-system/Button"));
const Card_1 = __importDefault(require("components/design-system/Card"));
const Dropdown_1 = __importDefault(require("components/design-system/dropdown/Dropdown"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const TruncateParagraph_1 = __importDefault(require("components/shared/TruncateParagraph"));
const ModalConnectJira_1 = __importDefault(require("./ModalConnectJira"));
const ModalRemoveJira_1 = __importDefault(require("./ModalRemoveJira"));
const JiraCardComponent = ({ objectiveDetail, type = 'edit', setObjectiveValue, changeValue }) => {
    const { id: objectiveId, integrations, measurement, permissions, childrenCount } = (0, react_1.useMemo)(() => objectiveDetail, [objectiveDetail]);
    const currentIntegration = (0, react_1.useMemo)(() => integrations?.[0], [integrations]);
    const { addToast } = (0, ToastContext_1.useToastContext)();
    const { refetchObjective } = (0, RefetchQueryContext_1.useRefetchQuery)();
    const { listMetrics } = (0, MetricsContext_1.useMetrics)() || {};
    const { config: { defaultRollupForParentObjective } } = (0, UserContext_1.useUser)();
    const [showModal, setShowModal] = (0, react_1.useState)({ show: false, type: null });
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const isAbleToUpdate = type == 'create' || (type == 'edit' && permissions?.includes('update'));
    const otherOptions = (0, react_1.useMemo)(() => [
        {
            text: (0, HelperUtils_1.getObjectiveLocale)('Edit link'),
            iconName: 'icon-create',
            onClick: () => setShowModal({ show: true, type: 'edit' }),
            isVisible: true
        },
        {
            text: (0, HelperUtils_1.getObjectiveLocale)('Import child issues'),
            iconName: 'icon-file_upload',
            onClick: () => setShowModal({ show: true, type: 'import-child' }),
            isVisible: type == 'edit'
        },
        {
            text: (0, HelperUtils_1.getObjectiveLocale)('Remove link'),
            iconName: 'icon-delete',
            onClick: () => setShowModal({ show: true, type: 'remove' }),
            isVisible: true,
            iconColor: 'var(--r-600)',
            textColor: 'text-r-600'
        }
    ].filter(({ isVisible }) => isVisible), []);
    const _syncJIRA = async () => {
        setIsLoading(true);
        const { isSuccess } = await (0, ObjectivesClient_1.syncJIRA)(objectiveId, currentIntegration?.id);
        if (isSuccess) {
            addToast({
                msg: (0, HelperUtils_1.getObjectiveLocale)('Sync success'),
                type: 'success'
            });
        }
        refetchObjective(objectiveId);
        setIsLoading(false);
    };
    const removeCurrentJira = () => {
        const defaultMetric = listMetrics?.find(({ isDefaultForGoal }) => isDefaultForGoal) || listMetrics?.[0];
        setObjectiveValue?.((draft) => {
            draft.integrations = [];
            draft.measurement = {
                ...draft.measurement,
                rollUp: defaultMetric?.defaultRollUp || defaultRollupForParentObjective
            };
        });
        changeValue?.(objectiveId, {
            integrations: [],
            measurement: {
                ...measurement,
                rollUp: defaultMetric?.defaultRollUp || defaultRollupForParentObjective
            }
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Card_1.default, { customClass: `mx-[24px] ${currentIntegration?.key ? '!pt-[8px] !pb-[12px]' : '!py-[4px]'} !px-[16px] !rounded-[4px]`, borderColor: "border-n-300", bgColor: "bg-n-200", useHorizontalPadding: false, useVerticalPadding: false },
            react_1.default.createElement("div", { className: "flex justify-between min-h-[32px]" },
                react_1.default.createElement("div", { className: "flex items-center" },
                    react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-jira", size: 24, customClass: "mr-[8px]" }),
                    react_1.default.createElement("p", { className: "typography-paragraph text-n-900" }, (0, HelperUtils_1.getObjectiveLocale)('JIRA Integration')),
                    currentIntegration?.updatedAt && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-circle-sync", size: 16, fillColor: isLoading ? 'var(--base-600)' : 'var(--n-600)', customClass: "ml-[8px] mr-[4px]" }),
                        react_1.default.createElement("p", { className: `typography-h100 ${isLoading ? 'text-base-600' : 'text-n-600'}` }, isLoading ? ((0, HelperUtils_1.getObjectiveLocale)('Sync in progress')) : (react_1.default.createElement(react_1.default.Fragment, null,
                            (0, HelperUtils_1.getObjectiveLocale)('Last synced '),
                            (0, timeago_js_1.format)(currentIntegration?.updatedAt))))))),
                currentIntegration?.key
                    ? isAbleToUpdate && (react_1.default.createElement("div", { className: "flex items-center" },
                        type == 'edit' && (react_1.default.createElement(Button_1.default.Tertiary, { disabled: isLoading, onClick: _syncJIRA, customClass: "mr-[8px]" }, (0, HelperUtils_1.getObjectiveLocale)('Sync'))),
                        react_1.default.createElement(Dropdown_1.default, null,
                            react_1.default.createElement(Dropdown_1.default.Trigger, { dataCy: "jira-other-button" },
                                react_1.default.createElement(SVGIcon_1.default, { size: 24, fillColor: "var(--n-600)", iconName: "icon-keyboard_control" })),
                            react_1.default.createElement(Dropdown_1.default.MenuItems, { type: "fixed", options: otherOptions, position: "right" }))))
                    : isAbleToUpdate && (react_1.default.createElement(Button_1.default.Tertiary, { onClick: () => setShowModal({ show: true, type: 'connect' }) }, (0, HelperUtils_1.getObjectiveLocale)('Connect Data')))),
            currentIntegration?.key && (react_1.default.createElement("div", { className: "pl-[32px]" },
                react_1.default.createElement("div", { className: "flex items-center" },
                    react_1.default.createElement(AWSImage_1.default, { src: currentIntegration?.integrationType === 'project'
                            ? currentIntegration?.data?.avatarUrls?.['24x24'] ||
                                currentIntegration?.data?.avatarUrls?.['24X24']
                            : currentIntegration?.data?.fields?.issuetype?.iconUrl, className: "rounded-[4px] w-[16px] h-[16px] mr-[8px]" }),
                    react_1.default.createElement("p", { className: "typography-h400 text-n-600 mr-[8px]" }, currentIntegration?.data?.key),
                    react_1.default.createElement("div", { className: "cursor-pointer max-w-[440px]", onClick: () => window.open(currentIntegration?.url, '_blank') },
                        react_1.default.createElement(TruncateParagraph_1.default, { position: "bottom", className: "typography-link text-base-600", align: "right" }, currentIntegration?.integrationType == 'project'
                            ? currentIntegration?.data?.name
                            : currentIntegration?.data?.fields?.summary))),
                react_1.default.createElement("p", { className: "typography-h100 text-n-600 mr-[8px] mt-[4px]" }, (0, HelperUtils_1.getObjectiveLocale)(`This goal ${currentIntegration?.syncOption === 'all'
                    ? 'sync with all information'
                    : 'only sync progress and completion'}`))))),
        showModal?.show &&
            (showModal?.type == 'connect' ||
                showModal?.type == 'edit' ||
                showModal?.type == 'import-child') && (react_1.default.createElement(ModalConnectJira_1.default, { closeCurrentModal: () => setShowModal({ show: false, type: null }), objectiveId: objectiveId, objectiveChildrenCount: childrenCount, currentIntegration: currentIntegration, modalType: showModal?.type, setObjectiveValue: setObjectiveValue, changeValue: changeValue })),
        showModal?.show && showModal?.type == 'remove' && (react_1.default.createElement(ModalRemoveJira_1.default, { closeCurrentModal: () => setShowModal({ show: false, type: null }), objectiveId: objectiveId, objectiveChildrenCount: childrenCount, currentIntegration: currentIntegration, removeCurrentJira: removeCurrentJira, type: type }))));
};
const JiraCard = (props) => {
    return (react_1.default.createElement(MetricsContext_2.MetricsProvider, { type: props?.objectiveDetail?.type },
        react_1.default.createElement(JiraCardComponent, { ...props })));
};
exports.default = JiraCard;
